"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Card = _interopRequireWildcard(require("./Card"));

var _Avatar = require("../Avatar");

var _reactI18next = require("react-i18next");

var _Icons = require("../Icons");

var _default = function _default(_ref) {
  var onReview = _ref.onReview,
      onIgnore = _ref.onIgnore,
      type = _ref.type,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["onReview", "onIgnore", "type"]);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Card["default"], (0, _extends2["default"])({}, rest, {
    info: {
      avatar: /*#__PURE__*/_react["default"].createElement(_Avatar.IconAvatar, {
        icon: /*#__PURE__*/_react["default"].createElement(_Icons.Cleanup, {
          style: {
            fontSize: '2rem'
          },
          className: "text-white"
        }),
        containerProps: {
          className: 'bg-primary'
        }
      }),
      title: t('cleanup.calendar.card.title'),
      subtitle: t('cleanup.calendar.card.subtitle'),
      extra: null
    },
    subject: /*#__PURE__*/_react["default"].createElement(_Card.CardSubject, {
      size: "small"
    }, t('cleanup.calendar.card.subject')),
    actions: [/*#__PURE__*/_react["default"].createElement(_Card.CardAction, {
      color: "secondary",
      onClick: onIgnore
    }, t('button.ignore')), /*#__PURE__*/_react["default"].createElement(_Card.CardAction, {
      onClick: onReview
    }, t('button.review'))]
  }));
};

exports["default"] = _default;
//# sourceMappingURL=CleanupCard.js.map